import React from 'react';
import { PublicLayout } from '@/components/PublicLayout';

interface PublicLayoutWrapperProps {
  children: React.ReactNode;
}

const PublicLayoutWrapper: React.FC<PublicLayoutWrapperProps> = ({ children }) => {
  return (
    <PublicLayout>
      {children}
    </PublicLayout>
  );
};

export default PublicLayoutWrapper;